<template>
    <div>
        <PageHeader :page="page" :template="2" @action="createNew" v-if="!state.loading"/>
        <div class="content" v-if="!state.loading">
            <DataTable :tableData="tableData" @view="viewTransaction" @edit="edit"/>
        </div>
        <div v-if="state.loading" style="text-align: center;">
          <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>

    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="1"
        :fields="newFields" @submit="addTransaction"
        :submitting="state.submitting" :errors="state.errors"
        :success="state.success" />
    </ModalView> 

    <ModalView
        :isVisible="state.ViewModal"
        :fixclose="true"
        @close="state.ViewModal = false">
        
        <div v-if="!state.modalLoading">
            <FormView :columns="1"
                :fields="viewFields" 
                :loading="state.modalLoading" />
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </ModalView> 

    <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">

        <div v-if="!state.modalLoading">
            <DynamicForm :columns="1" @submit="editTransaction"
                :fields="editFields" 
                :submitting="state.submitting" 
                :errors="state.errors"
                :success="state.success"
            />
        </div>
        <div v-else style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </ModalView> 
    
</template>
<script>
import icons from '@/assets/js/icons.js';
import { reactive, ref, onMounted, computed} from 'vue';
import { useStore } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import DataTable from '@/components/DataTable.vue';
import { usePermissions } from '@/composables/usePermissions';
import DynamicForm from '@/components/DynamicForm.vue';
import ModalView from '@/components/ModalView.vue';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls";
import FormView from '@/components/FormView.vue';
export default {
    name: 'TransactionsView',
    components:{PageHeader, DataTable,DynamicForm,ModalView,FormView},
    setup(){
        const store= useStore();
        const system = computed(() => store.state.System.system);
        const viewFields=ref([])
        const editFields=ref([]);
        const { hasPermission } = usePermissions();
        const accounts=ref([]);
        const state=reactive({CreateModal:false, submitting:false,error:[],success:false,
        loading:true,editTaskModal:false,gettingTask:false,historyModal:false,historyLoading:true
        });
        const svgIcons = ref(icons);
        const page=ref({title:"Transaction", btn:"Add",
            desc:"Manage all transaction in one place"})
        if(!hasPermission('Transactions', 'create')){
            page.value.btn="";
        }
        var action_label=[icons.view],
        action=["view"]
        if(hasPermission('Transactions', 'edit')){
            action_label.push(icons.edit);
            action.push("edit")
        }

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Date" },
                { label: "Description" },
                { label: "Account" },
                { label: "Type" },
                { label: "Amount" },
            ],
            options:{
                label:"Actions",
                action_label:action_label,
                action:action,
            },
            total:0
        });

        

        if(system.value.acct_type=="simple"){
            tableData.value.columns.splice(2, 1);
        }

        onMounted(() => {
            call({
                url:urls.transactions,
                data:{startTransactions:""},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        var d=res.msg;
                        accounts.value=[];
                        Object.keys(d.accounts).forEach(k => {
                            accounts.value.push(d.accounts[k])
                        })
                        setTable(d.transactions);
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        const newFields=ref([
            { name: "Add Transaction", number: "1",data: 
                [{ type: 'text', name: 'desc', label: 'Description',
                value: ""  },
                { type: 'select', name: 'account', label: 'Account',
                    value: "", options:accounts},
                { type: 'text', name: 'amount', label: 'Amount',
                value: ""  },
                { type: 'select', name: 'type', label: 'Type',
                    value: "", options:[{label:"Credit",value:"credit"},{label:"Debit",value:"debit"}]},
                { type: 'date', name: 'date', label: 'Transaction Date',
                    value: ""},
                { type: 'text', name: 'ref', label: 'Reference No.',
                    value: ""  },
                { type: 'textarea', name: 'note', label: 'Note',
                    value: ""  },]
            }
        ])

        if(system.value.acct_type == "simple"){
            newFields.value.length=0;
            newFields.value.push(
                { name: "Add Transaction", number: "1",
                data: 
                    [
                        { type: 'text', name: 'desc', label: 'Description',
                        value: ""  },
                        { type: 'text', name: 'amount', label: 'Amount',
                        value: ""  },
                        { type: 'select', name: 'type', label: 'Type',
                            value: "", options:[{label:"Income",value:"credit"},{label:"Expense",value:"debit"}]},
                        { type: 'date', name: 'date', label: 'Transaction Date',
                            value: ""},
                        { type: 'text', name: 'ref', label: 'Reference No.',
                            value: ""  },
                        { type: 'textarea', name: 'note', label: 'Note',
                            value: ""  }
                    ]
                }
            )
        }

        function createNew(){
            if(system.value.acct_type==""){
                alert("Office accounting settings not found. Please contact your system administrator to configure accounting settings to continue")
            }else{
                state.success=false;
                state.error=[]
                state.CreateModal=true;
            }
        }

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
                var e=res.msg[key],er="";
                Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
                })
                errors.push(er);
            });
            state.errors=errors;
        }

        function addTransaction(data){
            state.submitting=true;
            state.errors=[];
            data.addTransaction="";
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg)
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function editTransaction(data){
            state.submitting=true;
            state.errors=[];
            data.addTransaction="";
            call({
                url:urls.transactions,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    setTable(res.msg)
                }else{
                    setErrors(res)
                }
                }
            })
        }

        function viewTransaction(i){
            state.modalLoading=true
            state.ViewModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.transactions,
                data:{getTransaction:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        viewFields.value.length=0;
                        var d=res.msg;
                        viewFields.value.push(
                            { name: "Transaction Details", number: "1",data: 
                                [{name: 'date', label: 'Transaction Date',
                                    value: d.date},
                                {name: 'desc', label: 'Description',
                                value: d.description },
                                {name: 'account', label: 'Account',
                                    value: d.acct_name},
                                {name: 'type', label: 'Transaction Type',
                                    value: d.type},
                                {name: 'amount', label: 'Amount',
                                value: d.amount },
                                {name: 'ref', label: 'Reference No.',
                                    value: d.ref_num  },
                                {name: 'note', label: 'Note',
                                    value: d.note  },
                                {name: 'add', label: 'Added By',
                                    value: d.added_by  },]
                            }
                        );
                        if(system.value.acct_type=="simple"){
                            viewFields.value[0].data.splice(2, 1);
                        }
                    }else{
                        setErrors(res)
                    }
                }
            })
        }

        function edit(i){
            state.modalLoading=true
            state.editModal=true;
            state.success=false;
            state.submitting=false;
            state.errors=[];
            var id=tableData.value.rows[i].id
            call({
                url:urls.transactions,
                data:{editTransaction:id},
                success:(res)=>{
                    state.modalLoading=false;
                    if(res.status){
                        editFields.value.length=0;
                        var msg=res.msg,
                        d=msg.transaction;
                        accounts.value=[];
                        Object.keys(msg.accounts).forEach(k => {
                            accounts.value.push(msg.accounts[k])
                        })
                        editFields.value.push(
                            { name: "Edit Transaction", number: "1",data: 
                                [{ type: 'text', name: 'desc', label: 'Description',
                                value: d.description  },
                                { type: 'select', name: 'account', label: 'Account',
                                    value: d.account, options:accounts},
                                { type: 'text', name: 'amount', label: 'Amount',
                                value: d.amount  },
                                { type: 'select', name: 'type', label: 'Type',
                                    value: d.type, options:[{label:"Credit",value:"credit"},{label:"Debit",value:"debit"}]},
                                { type: 'date', name: 'date', label: 'Transaction Date',
                                    value: d.date},
                                { type: 'text', name: 'ref', label: 'Reference No.',
                                    value: d.ref_num  },
                                { type: 'textarea', name: 'note', label: 'Note',
                                    value: d.note  },
                                { type: 'hidden', name: 'id', value: id  }]
                            }
                        );
                        if(system.value.acct_type=="simple"){
                            editFields.value[0].data.splice(1, 1);
                        }
                    }else{
                        setErrors(res)
                    }
                }
            })
        }
        

        return{state, icons:svgIcons,tableData,page,newFields,createNew,edit,
            addTransaction,viewTransaction,viewFields,editTransaction, editFields}
    }
}
</script>